import {
  ButtonGroup,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';

import OutlineButton from '@/client/components/shared/buttons/OutlineButton';
import SolidButton from '@/client/components/shared/buttons/SolidButton';
import { useGetPublicImage } from '@/client/services/hooks/media/useGetPublicImage';
import { useTranslation } from 'react-i18next';

// TODO: Consolidate all of these similar content creation modals into a single component

/** Pre-localised overrides for the modal text; each falls back to the generic authoring copy. */
export interface DiscardModalCopy {
  title?: string;
  body?: string;
  discardLabel?: string;
  keepLabel?: string;
}

interface DiscardModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDiscard: () => void;
  copy?: DiscardModalCopy;
}

export default function DiscardModal({ isOpen, onClose, onDiscard, copy }: DiscardModalProps) {
  const { t } = useTranslation();
  const { getPublicImage } = useGetPublicImage();

  return (
    <Modal isCentered isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />

      <ModalContent>
        <ModalBody paddingTop={12}>
          <VStack textAlign="center">
            <Image
              src={getPublicImage('continu/app-images/discard.svg')}
              width={120}
              height="auto"
            />

            <Text fontSize="20px" fontWeight={600} color="baseBlack">
              {copy?.title ?? t('authoring.discardModal.areYouSure')}
            </Text>
            {copy?.body && (
              <Text fontSize="14px" fontWeight={500} color="neutral.1000">
                {copy.body}
              </Text>
            )}
          </VStack>
        </ModalBody>

        <ModalFooter paddingX={10} paddingBottom={8} paddingTop={10}>
          <ButtonGroup width="full" alignItems="center" justifyContent="center">
            <OutlineButton onClick={onDiscard}>
              {copy?.discardLabel ?? t('authoring.discardModal.discardProgess')}
            </OutlineButton>

            <SolidButton onClick={onClose}>
              {copy?.keepLabel ?? t('authoring.keepEditing')}
            </SolidButton>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
